import { isValidJson } from '@/src/api';
import type { ApiResponse } from '@/src/core/rest-api/types';
import type { ClientExtended } from '@/src/domain/entities';

export const client = {
  getById: async (id: string, cookie: string | null): Promise<ClientExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/clients/${id}`, {
      method: 'GET',
      headers: {
        Cookie: `${cookie}`,
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      }
    });

    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<ClientExtended> = JSON.parse(responseText);
        return data.success ? data.data : undefined;
      }
    }

    return undefined;
  },
  getAll: async (cookie: string | null): Promise<ClientExtended[]> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/clients`, {
      method: 'GET',
      headers: {
        Cookie: `${cookie}`,
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      }
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<ClientExtended[]> = JSON.parse(responseText);
        return (data.success && data.data) || [];
      }
    }

    return [];
  },
  create: async (data: Partial<ClientExtended>): Promise<ClientExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/clients`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      },
      body: JSON.stringify(data)
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<ClientExtended> = JSON.parse(responseText);
        return (data.success && data.data) || undefined;
      }
    }

    return undefined;
  },
  update: async (data: Partial<ClientExtended>): Promise<ClientExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/clients/${data.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<ClientExtended> = JSON.parse(responseText);
        return (data.success && data.data) || undefined;
      }
    }

    return undefined;
  },
  delete: async (id: number): Promise<boolean> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/clients/${id}`, {
      method: 'DELETE',
      headers: {
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      }
    });

    return response.ok;
  }
};
